module.exports = __webpack_public_path__ + "static/img/p2.ac6b7da.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/p2.png
// module id = Znc8
// module chunks = 1